import React from 'react';
// @ts-ignore FIXME: Try `npm install @types/rc-form` if it exists or a... Remove this comment to see the full error message
import { formShape } from 'rc-form';
import LocationInterface from '@solvhealth/types/interfaces/Location';
import { PaperworkCopyFormFieldsCheckboxName } from '../paperworkConstants';
import PaperworkCopyFormFieldsCheckbox from '../components/PaperworkCopyFormFieldsCheckbox';
import { getStandardFormFieldData, isPaperworkForChild, PaperworkField } from '.';
import { useSolvSelector } from '~/reducers';
import { validateFamilyBooking } from '../../../util/validateFamilyBooking';
import { usePaperworkContextBookingId } from '~/routes/paperwork/PaperworkBookingIdContext';
import { CheckboxMeta } from '../hooks';

type Props = {
  /** form object */
  form: formShape;

  /** field names for current page of paperwork */
  fieldNames: string[];

  /** preloaded paperwork data from newBooking, current booking, userProfile, and insuranceProfile  */
  preloadedData?: any;

  /**
   * optional side effect function for Family Bookings checkboxes that will be called with T/F depending on
   * if the checkbox is checked/unchecked
   */
  toggleSideEffect?: (wasChecked: boolean) => void;

  /**
   * optional second source of truth for if the checkbox is enabled, used for situations like copying insurance where
   * the information about if there are fields to copy comes from another source than the primary paperwork (i.e. if
   * there is an insurance image that is able to be copied over but none of the fields have been filled out yet)
   */
  checkboxEnabled?: boolean;

  /**
   * metadata about FB checkbox, if it's enabled, if it should be checked initially, any conditions that might lead to
   * if autofill fields are/aren't available (such as for insurance, which doesn't check paperwork responses, but rather
   * if insurance images are available for the primary booking)
   */
  checkboxMeta?: CheckboxMeta;

  /**
   * function that takes a field name and will return T (or a warning string) or F if a warning should be set on a field
   */
  handleSetWarning?: (fieldName: string) => string | boolean;
};

const paperworkCopyFormFieldsCheckboxNameSet = new Set(
  Object.values(PaperworkCopyFormFieldsCheckboxName)
);
const CHECKBOXES_FOR_ALL_PAPERWORK = [
  PaperworkCopyFormFieldsCheckboxName.GUARDIAN_ADDRESS,
  PaperworkCopyFormFieldsCheckboxName.GUARANTOR_INFO,
];

const PaperworkFields = (props: Props) => {
  const {
    form,
    fieldNames,
    preloadedData,
    toggleSideEffect,
    checkboxEnabled,
    checkboxMeta,
    handleSetWarning,
  } = props;

  const bookingId = usePaperworkContextBookingId();
  const booking = useSolvSelector((state) => state.pastBookings[bookingId]);
  const location = useSolvSelector((state) => state.location as LocationInterface);
  const paperwork = useSolvSelector((state) => state.paperwork);

  const { isPrimary, isFamilyBooking } = validateFamilyBooking(booking);

  return (
    <>
      {fieldNames.map((fieldName: string, index: number) => {
        if (
          paperworkCopyFormFieldsCheckboxNameSet.has(
            fieldName as PaperworkCopyFormFieldsCheckboxName
          )
        ) {
          if (
            (isFamilyBooking && isPrimary) ||
            (!isFamilyBooking &&
              !CHECKBOXES_FOR_ALL_PAPERWORK.includes(
                fieldName as PaperworkCopyFormFieldsCheckboxName
              )) ||
            !isPaperworkForChild(
              paperwork.formData,
              preloadedData.userProfile,
              preloadedData.newBooking
            )
          ) {
            return null;
          }
          return (
            <PaperworkCopyFormFieldsCheckbox
              booking={booking}
              checkboxEnabled={checkboxEnabled}
              checkboxMeta={checkboxMeta}
              checkboxName={fieldName as PaperworkCopyFormFieldsCheckboxName}
              form={form}
              key={fieldName}
              noTopMargin={index === 0}
              toggleSideEffect={toggleSideEffect}
            />
          );
        }
        return (
          <PaperworkField
            key={fieldName}
            {...{
              field: getStandardFormFieldData(fieldName, paperwork),
              handleSetWarning,
              paperwork,
              form,
              preloadedData,
              location,
            }}
          />
        );
      })}
    </>
  );
};

export default PaperworkFields;
